
import React from 'react';
import { Article } from '@/data/articles';
import ValuedPeopleCard from './ValuedPeopleCard';
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious
} from '@/components/ui/carousel';
import { cn } from '@/lib/utils';

interface ValuedPeopleCarouselProps {
  articles: Article[];
  className?: string;
  autoplay?: boolean;
  autoplaySpeed?: number;
  showControls?: boolean;
  enhancedImages?: boolean;
}

const ValuedPeopleCarousel: React.FC<ValuedPeopleCarouselProps> = ({ 
  articles, 
  className,
  autoplay = false,
  autoplaySpeed = 5000,
  showControls = true,
  enhancedImages = false
}) => {
  // Check if this carousel is for highly valued people
  const isPremiumCarousel = className?.includes('premium-carousel');

  return (
    <div className={cn("w-full", className)}>
      <Carousel
        opts={{
          align: "start",
          loop: true,
        }}
        autoplay={autoplay}
        delayLength={autoplaySpeed}
        className="w-full"
      >
        <CarouselContent className="-ml-4">
          {articles.map((article) => (
            <CarouselItem 
              key={article.id} 
              className="pl-4 sm:basis-1/2 md:basis-1/3 lg:basis-1/4 xl:basis-1/5 h-full"
            >
              <div className="h-full">
                <ValuedPeopleCard 
                  article={article} 
                  className="h-full" 
                  enhancedImage={enhancedImages}
                />
              </div>
            </CarouselItem>
          ))}
        </CarouselContent>
        {showControls && (
          <div className={cn(
            "flex justify-end space-x-2 mt-4",
            isPremiumCarousel && "mt-6"
          )}>
            <CarouselPrevious className={cn(
              "relative static left-0 right-auto translate-y-0 font-montserrat",
              isPremiumCarousel && "bg-purple-100 border-purple-200 hover:bg-purple-200 text-purple-800"
            )} />
            <CarouselNext className={cn(
              "relative static right-0 left-auto translate-y-0 font-montserrat",
              isPremiumCarousel && "bg-purple-100 border-purple-200 hover:bg-purple-200 text-purple-800"
            )} />
          </div>
        )}
      </Carousel>
    </div>
  );
};

export default ValuedPeopleCarousel;
